import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../utils/colors";

interface IProps {
  defaultState?: boolean;

  onChange: (bool: boolean) => void;
}
const CheckBox = ({ defaultState = false, onChange }: IProps) => {
  const [checked, setChecked] = useState(defaultState);

  useEffect(() => {
    setChecked(defaultState);
  }, [defaultState]);

  return (
    <Container
      onClick={() => {
        const check = checked;
        setChecked(!check);
        onChange(!check);
      }}
    >
      {checked ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
        >
          <path
            fill={Colors.yellow400}
            fill-rule="evenodd"
            d="M12 22c-4.714 0-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12s0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22m4.03-13.03a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47l4.47-4.47a.75.75 0 0 1 1.06 0"
            clip-rule="evenodd"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
        >
          <g fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z" />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.5 12.5l2 2l5-5"
            />
          </g>
        </svg>
      )}
    </Container>
  );
};

export default CheckBox;

const Container = styled.div`
  cursor: pointer;
  width: 1.8rem;
  height: 1.8rem;
`;
